<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import ImageSliderView from './ImageSlider.View.svelte';

    import type { ImageSliderContent } from '$lib/types/Components/ImageSlider/ImageSliderContent';
    import type { Language } from '$lib/types/Language';
    import type { TransitionEffect } from '$lib/types/Theme';

    export let id = '';
    export let content: ImageSliderContent;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let layout = DEFAULT_LAYOUT;
    export let language: Language = 'en';
</script>

<ImageSliderView
    {id}
    images={content.images}
    framed={content.framed}
    size={content.size}
    bgColor={content.box.backgroundColor}
    {transitionDelay}
    {transitionEffect}
    {layout}
    {language}
/>
